export var PositionTimeUnit;
(function (PositionTimeUnit) {
    PositionTimeUnit["SECONDS"] = "SECONDS";
    PositionTimeUnit["MINUTES"] = "MINUTES";
})(PositionTimeUnit || (PositionTimeUnit = {}));
//# sourceMappingURL=PositionTimeUnit.js.map